function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M70,12H30c-9.9,0-18,8.1-18,18v40c0,9.9,8.1,18,18,18h40c9.9,0,18-8.1,18-18V30C88,20.1,79.9,12,70,12z M84,70 c0,3.9-1.6,7.4-4.1,9.9c-2.5,2.5-6,4.1-9.9,4.1H30c-3.9,0-7.4-1.6-9.9-4.1c-2.5-2.5-4.1-6-4.1-9.9V30c0-3.9,1.6-7.4,4.1-9.9 c2.5-2.5,6-4.1,9.9-4.1h40c3.9,0,7.4,1.6,9.9,4.1c2.5,2.5,4.1,6,4.1,9.9V70z",
    id: "id_101",
    style: {
      fill: "rgb(27, 27, 27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,40.6L46.9,55.2l-7.5-6.7c-0.8-0.7-2.1-0.7-2.8,0.2s-0.7,2.1,0.2,2.8l9,8c0.8,0.7,2,0.7,2.8-0.1l15-16 c0.8-0.8,0.7-2.1-0.1-2.8C62.6,39.8,61.3,39.8,60.5,40.6z",
    id: "id_102",
    style: {
      fill: "rgb(27, 27, 27)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.6a54878a1ad45022e2d2439e4d2f88f1.svg";
export { ForwardRef as ReactComponent };